export default {
  pages: [],
  history: [],
  accountPagesRequestId: 0,
  historyRequestId: 0,
  historyCursor: null,
  historyHasMore: false,
  loadingMoreHistory: false,
  historyLoadMoreError: false,
  activePage: null,
  requestStatus: 'loading',
  loadingHistory: true,
  historyIsLoaded: false,
};
